import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoahmednagartaxi() {



    const cardData = {

keyword: "Pune to Ahmednagar Taxi",

headingDescription:
    "Rising Cab Service offers safe and affordable Pune to Ahmednagar Taxi services for families, business travelers, students, and daily commuters. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for a smooth and comfortable highway journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for work, education, or family visits, Rising Cab Service ensures a hassle-free and reliable travel experience to Ahmednagar.",

topPlaces: [
    {
        title: "Meherabad (Meher Baba Samadhi)",
        description:
            "Meherabad is a famous spiritual destination near Ahmednagar, known as the resting place of Meher Baba. It attracts devotees from across the world for its peaceful environment and annual gatherings."
    },
    {
        title: "Ahmednagar Fort",
        description:
            "Ahmednagar Fort is a historic fort built by the Nizam Shahi dynasty and later used by the British. It is known for its strong architecture and historical significance."
    },
    {
        title: "Shirdi (Nearby Pilgrimage)",
        description:
            "Shirdi is one of the most visited pilgrimage destinations in Maharashtra, dedicated to Sai Baba. It is located close to Ahmednagar and attracts millions of devotees."
    },
    {
        title: "Rehekuri Blackbuck Sanctuary",
        description:
            "Rehekuri Sanctuary is a protected area near Ahmednagar known for blackbucks, wildlife conservation, and natural grassland ecosystems."
    },
    {
        title: "Cavalry Tank Museum",
        description:
            "The Cavalry Tank Museum in Ahmednagar showcases a unique collection of tanks used in wars, offering a fascinating experience for history and defense enthusiasts."
    },
    {
        title: "Bhandardara (Nearby Hill Station)",
        description:
            "Bhandardara is a scenic hill station near Ahmednagar known for Arthur Lake, Randha Falls, and lush green landscapes, making it a popular weekend getaway."
    },
    {
        title: "Renuka Mata Temple",
        description:
            "Renuka Mata Temple is a revered religious site near Ahmednagar visited by devotees for spiritual blessings and peaceful surroundings."
    },
    {
        title: "Salabat Khan Tomb",
        description:
            "Salabat Khan Tomb is a historical monument located on a hill offering panoramic views of Ahmednagar city and showcasing Mughal-era architecture."
    },
    {
        title: "Cement Industry Belt",
        description:
            "Ahmednagar is part of Maharashtra’s industrial region with several cement and manufacturing plants, making it an important business travel destination."
    },
    {
        title: "Mula Dam",
        description:
            "Mula Dam near Ahmednagar is a scenic water reservoir surrounded by natural beauty, ideal for picnics and peaceful outings."
    }
],



services: [
    {
        name: "Pune to Ahmednagar Cab",
        description:
            "Rising Cab Service offers Pune to Ahmednagar Cab for safe, fast, and comfortable intercity travel. This route is ideal for business trips, family visits, educational travel, and short outstation journeys. We provide well-maintained AC vehicles including hatchbacks, sedans, SUVs, Innova, and Innova Crysta with professional drivers experienced on highway routes. Customers can choose one-way or round-trip options with door-to-door pickup and drop service. With transparent pricing, 24x7 availability, and reliable service, we ensure a smooth and stress-free journey between Pune and Ahmednagar."
    },
    {
        name: "Pune to Ahmednagar Taxi",
        description:
            "Book Pune to Ahmednagar Taxi with Rising Cab Service for affordable and comfortable travel. Our taxis are suitable for solo passengers, families, and corporate travelers who want safe and timely transportation with professional chauffeurs and clean vehicles."
    },
    {
        name: "Cab from Pune to Ahmednagar",
        description:
            "Rising Cab Service provides Cab from Pune to Ahmednagar with flexible pickup options, AC vehicles, and reliable drivers ensuring smooth and punctual intercity travel."
    },
    {
        name: "Taxi from Pune to Ahmednagar",
        description:
            "Our Taxi from Pune to Ahmednagar service ensures safe highway travel with experienced drivers, comfortable seating, and budget-friendly pricing for all types of passengers."
    },
    {
        name: "Pune to Ahmednagar Cab Service",
        description:
            "Rising Cab Service offers Pune to Ahmednagar Cab Service with easy booking, clean vehicles, and dependable transportation for families, tourists, and business travelers."
    },
    {
        name: "Pune to Ahmednagar Taxi Fare",
        description:
            "Get transparent and affordable Pune to Ahmednagar Taxi Fare with no hidden charges. We offer economical pricing suitable for short and frequent intercity travel."
    },
    {
        name: "Pune to Ahmednagar One Way Cab",
        description:
            "Book Pune to Ahmednagar One Way Cab for cost-effective single-trip travel with comfortable vehicles and professional drivers."
    },
    {
        name: "Pune to Ahmednagar Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Ahmednagar Round Trip Taxi with flexible return timing, waiting options, and customized travel plans for families and corporate users."
    },
    {
        name: "Pune to Ahmednagar Cab Booking",
        description:
            "Our Pune to Ahmednagar Cab Booking service offers instant confirmation, multiple vehicle choices, and 24x7 support for smooth travel planning."
    },
    {
        name: "Cheap Pune to Ahmednagar Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Ahmednagar Cab with budget-friendly fares while ensuring safety, comfort, and reliable service quality."
    },
    {
        name: "Best Pune to Ahmednagar Taxi",
        description:
            "Choose the Best Pune to Ahmednagar Taxi with Rising Cab Service for premium comfort, punctual service, and professional drivers ensuring smooth travel."
    },
    {
        name: "Sedan Pune to Ahmednagar Cab",
        description:
            "Our Sedan Pune to Ahmednagar Cab service is ideal for individuals and small families seeking affordable and comfortable intercity travel."
    },
    {
        name: "SUV Pune to Ahmednagar Taxi",
        description:
            "Book SUV Pune to Ahmednagar Taxi for spacious seating, extra luggage space, and comfortable group travel on highway routes."
    },
    {
        name: "Innova Pune to Ahmednagar Cab",
        description:
            "Rising Cab Service offers Innova Pune to Ahmednagar Cab for family and group travel with premium comfort and smooth highway experience."
    },
    {
        name: "Fast Route Taxi Pune Ahmednagar",
        description:
            "Our Fast Route Taxi Pune Ahmednagar service ensures quick and efficient travel using optimized highway routes for time-saving journeys with experienced drivers."
    },
    {
        name: "Pune to Ahmednagar Cabs",
        description:
            "Rising Cab Service provides Pune to Ahmednagar Cabs with one-way, round-trip, and customized travel solutions for all passenger needs."
    },
    {
        name: "Pune to Ahmednagar Cab Service",
        description:
            "Our Pune to Ahmednagar Cab Service ensures reliable transportation with professional chauffeurs and affordable pricing."
    },
    {
        name: "Pune to Ahmednagar Taxi Service",
        description:
            "Book Pune to Ahmednagar Taxi Service for safe and convenient intercity travel with door-to-door pickup and drop facilities."
    },
    {
        name: "Best Pune to Ahmednagar Cab",
        description:
            "Choose the Best Pune to Ahmednagar Cab for high-quality service, comfortable vehicles, and reliable travel experience."
    },
    {
        name: "One Way Pune to Ahmednagar Cab",
        description:
            "Book One Way Pune to Ahmednagar Cab for affordable single-direction travel with experienced drivers and clean vehicles."
    },
    {
        name: "Round Trip Pune to Ahmednagar Taxi",
        description:
            "Our Round Trip Pune to Ahmednagar Taxi service provides flexible travel planning with return journey options and customized packages."
    },
    {
        name: "Cheap Pune to Ahmednagar Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Ahmednagar Cab with economical fares and safe, comfortable travel options."
    },
    {
        name: "24x7 Pune to Ahmednagar Cab Service",
        description:
            "Book 24x7 Pune to Ahmednagar Cab Service with Rising Cab Service for round-the-clock availability and reliable transportation anytime."
    },
    {
        name: "Outstation Cab Pune to Ahmednagar",
        description:
            "Our Outstation Cab Pune to Ahmednagar service provides safe, comfortable, and affordable intercity travel for all passenger types."
    },
    {
        name: "Pune to Ahilyanagar Cabs",
        description:
            "Rising Cab Service offers Pune to Ahilyanagar Cabs (Ahmednagar) with flexible booking options and reliable highway travel."
    },
    {
        name: "Pune to Ahilyanagar Cab Service",
        description:
            "Book Pune to Ahilyanagar Cab Service for safe and convenient travel with professional drivers and clean vehicles."
    },
    {
        name: "Pune to Ahilyanagar Taxi Service",
        description:
            "Our Pune to Ahilyanagar Taxi Service ensures smooth intercity travel with affordable pricing and experienced chauffeurs."
    },
    {
        name: "Pune to Ahilyanagar Cab Booking",
        description:
            "Rising Cab Service provides Pune to Ahilyanagar Cab Booking with instant confirmation and 24x7 customer support."
    },
    {
        name: "Best Pune to Ahilyanagar Cab",
        description:
            "Choose the Best Pune to Ahilyanagar Cab for reliable service, comfortable vehicles, and stress-free travel."
    },
    {
        name: "One Way Pune to Ahilyanagar Cab",
        description:
            "Book One Way Pune to Ahilyanagar Cab for economical single-trip travel with professional drivers and flexible pickup options."
    },
    {
        name: "Round Trip Pune to Ahilyanagar Taxi",
        description:
            "Our Round Trip Pune to Ahilyanagar Taxi service provides return journey flexibility and comfortable long-distance travel."
    },
    {
        name: "Cheap Pune to Ahilyanagar Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Ahilyanagar Cab with budget-friendly fares and reliable transportation."
    }
],
tableData: [
    ["Pune to Ahmednagar Cab", "Pune to Ahmednagar Taxi"],
    ["Cab from Pune to Ahmednagar", "Taxi from Pune to Ahmednagar"],
    ["Pune to Ahmednagar One Way Cab", "Pune to Ahmednagar Round Trip Taxi"],
    ["Pune to Ahmednagar Cab Service", "Pune to Ahmednagar Taxi Fare"],
    ["Cheap Pune to Ahmednagar Cab", "Best Pune to Ahmednagar Taxi"],
    ["Sedan Pune to Ahmednagar Cab", "SUV Pune to Ahmednagar Taxi"],
    ["Innova Pune to Ahmednagar Cab", "Fast Route Taxi Pune Ahmednagar"],
    ["Pune to Ahmednagar Cab Booking", "Outstation Cab Pune to Ahmednagar"],
    ["Pune to Ahilyanagar Cab Service", "Pune to Ahilyanagar Taxi Service"],
    ["One Way Pune to Ahilyanagar Cab", "Round Trip Pune to Ahilyanagar Taxi"]
],




whychoose: [
    {
        WhyChooseheading: "Convenient Pune to Ahmednagar Taxi Service",
        WhyChoosedescription: "Rising Cab Service offers reliable Pune to Ahmednagar taxi services for business travel, family visits, educational trips, tourism, and personal transportation requirements."
    },
    {
        WhyChooseheading: "Quick and Comfortable Intercity Travel",
        WhyChoosedescription: "Travel between Pune and Ahmednagar in comfortable vehicles with experienced drivers who ensure a smooth and hassle-free journey."
    },
    {
        WhyChooseheading: "Perfect for One-Day and Multi-Day Trips",
        WhyChoosedescription: "Whether you need a same-day return taxi, one-way drop, or an extended travel package, we provide flexible travel options."
    },
    {
        WhyChooseheading: "Vehicle Choices for Every Passenger Requirement",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on group size and travel preferences."
    },
    {
        WhyChooseheading: "Popular for Business and Family Travel",
        WhyChoosedescription: "Many customers book Pune to Ahmednagar taxis for official meetings, family functions, social gatherings, educational purposes, and medical visits."
    },
    {
        WhyChooseheading: "Doorstep Pickup and Drop Facility",
        WhyChoosedescription: "Pickup services are available from homes, offices, hotels, Pune Airport, Railway Station, and all major locations across Pune and PCMC."
    },
    {
        WhyChooseheading: "Flexible Route and Travel Planning",
        WhyChoosedescription: "Customers can customize their journey by including sightseeing stops, business locations, temples, restaurants, or nearby destinations."
    },
    {
        WhyChooseheading: "Trusted Service for Frequent Travelers",
        WhyChoosedescription: "Rising Cab Service is preferred by travelers looking for punctual service, comfortable vehicles, and professional travel management."
    }
]
};

const faqData = [
    {
        question: "What are the common reasons travelers book a Pune to Ahmednagar taxi?",
        answer: "Customers frequently travel for business meetings, family visits, educational purposes, medical appointments, tourism, and social events."
    },
    {
        question: "Can I hire a taxi for a one-way trip to Ahmednagar?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for family travel on this route?",
        answer: "Ertiga and Innova Crysta are popular choices among families due to their spacious seating and travel comfort."
    },
    {
        question: "Are same-day return trips available?",
        answer: "Yes, customers can choose same-day return taxi services depending on their travel schedule."
    },
    {
        question: "Do you provide taxis for corporate and business travel?",
        answer: "Yes, many professionals use our Pune to Ahmednagar taxi service for meetings, site visits, and official travel."
    },
    {
        question: "Can groups hire larger vehicles for Ahmednagar travel?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for groups, family events, and corporate teams."
    },
    {
        question: "Is pickup available from Pune Airport and Railway Station?",
        answer: "Yes, travelers can start their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "Can nearby destinations be included in the travel itinerary?",
        answer: "Yes, customers can customize the route to include temples, tourist attractions, and other destinations near Ahmednagar."
    },
    {
        question: "Are advance reservations recommended for weekend travel?",
        answer: "Yes, advance booking helps secure preferred vehicle options during weekends, holidays, and peak travel periods."
    },
    {
        question: "How can I book a Pune to Ahmednagar Taxi?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ramesh Shinde",
        feedback:
            "I regularly travel to Ahmednagar for business work, and Rising Cab Service has consistently provided comfortable vehicles and punctual transportation every time.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Snehal Thorat",
        feedback:
            "Our family journey to Ahmednagar was pleasant from start to finish. The cab was clean, the driver was courteous, and the travel experience was very comfortable.",
        rating: 5
    }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Ahmednagar Taxi Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-ahmednagar-taxi.jpg",
"description": "Book Pune to Ahmednagar Taxi Service with Rising Cab Service for safe, fast, and comfortable intercity travel. Enjoy reliable one-way and round-trip cab service with AC sedans, SUVs, and Innova options at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-ahmednagar-taxi"
}
};






    return (
        <div>

<Helmet>
  <title>Pune to Ahmednagar Taxi Service | Fast & Reliable Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Ahmednagar Taxi Service for fast, safe, and affordable intercity travel. Get reliable one-way and round-trip cab service with sedan, SUV, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to ahmednagar cab, pune to ahmednagar taxi, cab from pune to ahmednagar, taxi from pune to ahmednagar, pune to ahmednagar cab service, pune to ahmednagar taxi fare, pune to ahmednagar one way cab, pune to ahmednagar round trip taxi, pune to ahmednagar cab booking, cheap pune to ahmednagar cab, best pune to ahmednagar taxi, sedan pune to ahmednagar cab, suv pune to ahmednagar taxi, innova pune to ahmednagar cab, fast route taxi pune ahmednagar, Pune to Ahmednagar Cab, Pune to Ahmednagar Cab Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoahmednagartaxi;